<ng-container *ngIf="!IsDGPSteps && !isAboutUs">
    <section class="tw-py-5 tw-px-4 lg:tw-px-20 tw-bg-white">
        <div class="tw-py-5 tw-bg-white tw-text-left">
            <p
                class="tw-text-center sm:tw-text-left tw-text-[28px] md:tw-text-[40px] tw-w-full tw-text-[#0F3172] tw-font-bold"
            >
                {{
                    "NEW_PRODUCTS.APPLY_NOW_STEPS.BUSINESS_FINANCING"
                        | translate
                }}
            </p>

            <!-- Desktop Timeline -->
            <div
                class="tw-hidden md:tw-block"
                [ngClass]="showBanks ? 'tw-my-10' : 'tw-mt-[40px] tw-mb-[16px]'"
            >
                <ol class="tw-flex tw-items-start tw-justify-between">
                    <!-- Dynamic Timeline Items -->
                    <li
                        *ngFor="
                            let step of steps;
                            let first = first;
                            let last = last;
                            let i = index
                        "
                        class="tw-relative tw-flex-1 tw-flex tw-flex-col tw-items-center"
                    >
                        <!-- Line and Dot -->
                        <div
                            class="tw-relative tw-flex tw-justify-center tw-items-center tw-h-16 tw-w-full"
                        >
                            <!-- Line logic: different for first and last items -->
                            <div
                                *ngIf="first"
                                class="tw-absolute tw-top-1/2 tw-left-1/2 tw-w-full tw-h-1 tw-bg-[#4B6EEC]"
                            ></div>
                            <div
                                *ngIf="!first && !last"
                                class="tw-absolute tw-top-1/2 tw-left-0 tw-w-full tw-h-1 tw-bg-[#4B6EEC]"
                            ></div>
                            <div
                                *ngIf="last"
                                class="tw-absolute tw-top-1/2 tw-left-0 tw-w-[50%] tw-h-1 tw-bg-[#4B6EEC]"
                            ></div>

                            <!-- Dot loggic -->
                            <div
                                class="tw-z-10 tw-flex tw-items-center tw-justify-center tw-w-5 tw-h-5 tw-bg-[#4B6EEC] tw-rounded-full"
                            >
                                <span
                                    class="tw-bg-white tw-w-2.5 tw-h-2.5 tw-rounded-full"
                                ></span>
                            </div>
                        </div>

                        <!-- Step name render-->
                        <div>
                            <p class="tw-font-semibold">
                                {{
                                    selectedLanguage === "en"
                                        ? step?.step
                                        : step?.stepBM
                                }}
                            </p>
                        </div>

                        <!-- Icon render -->
                        <div
                            class="tw-w-[90px] tw-h-[90px] tw-flex tw-items-center tw-justify-center"
                        >
                            <img
                                [src]="step.icon"
                                class="tw-w-full tw-h-full tw-object-contain"
                                alt="Step icon"
                            />
                        </div>

                        <!-- Content render -->
                        <div class="tw-mt-3 tw-text-center tw-px-7">
                            <p
                                class="tw-text-lg tw-font-bold tw-text-black-900"
                            >
                                {{
                                    selectedLanguage === "en"
                                        ? step?.title
                                        : step?.titleBM
                                }}
                            </p>
                            <p class="tw-text-sm tw-text-black-600">
                                {{
                                    selectedLanguage === "en"
                                        ? step?.description
                                        : step?.descriptionBM
                                }}
                            </p>
                        </div>
                    </li>
                </ol>
            </div>

            <!-- Mobile Carousel Version -->
            <div *ngIf="isMobile" class="tw-w-full">
                <div class="tw-relative">
                    <div
                        *ngFor="let item of steps; let i = index"
                        [@slideAnimation]="getSlideState(i)"
                        [style.display]="i === activeIndex ? 'block' : 'none'"
                        class="tw-w-full tw-transition-opacity tw-duration-300"
                    >
                        <div
                            class="tw-relative tw-p-4"
                            style="min-height: 300px"
                        >
                            <!-- Timeline with centered dot and line extending to the right -->
                            <div
                                class="tw-flex tw-justify-center tw-relative tw-h-6 tw-mb-5"
                            >
                                <!-- Line before dot (hidden) -->
                                <div
                                    [class.tw-bg-transparent]="i === 0"
                                    [class.tw-bg-blue-500]="i !== 0"
                                    class="tw-h-0.5 tw-flex-1 tw-my-3"
                                ></div>

                                <!-- Centered dot -->
                                <div
                                    class="tw-w-6 tw-h-6 tw-rounded-full tw-bg-blue-500 tw-flex tw-items-center tw-justify-center tw-text-white tw-z-10"
                                >
                                    <span
                                        class="tw-bg-white tw-w-2.5 tw-h-2.5 tw-rounded-full"
                                    ></span>
                                </div>

                                <!-- Line after dot -->
                                <div
                                    [class.tw-bg-transparent]="
                                        i === steps.length - 1
                                    "
                                    [class.tw-bg-blue-500]="
                                        i !== steps.length - 1
                                    "
                                    class="tw-h-0.5 tw-flex-1 tw-my-3"
                                ></div>
                            </div>

                            <!-- Step content -->
                            <div class="tw-pt-6">
                                <div
                                    class="tw-flex tw-flex-col tw-items-center tw-text-center"
                                >
                                    <!-- Step name -->
                                    <div>
                                        <p class="tw-font-semibold">
                                            {{
                                                selectedLanguage === "en"
                                                    ? item?.step
                                                    : item?.stepBM
                                            }}
                                        </p>
                                    </div>
                                    <!-- Icon -->
                                    <div
                                        class="tw-w-[90px] tw-h-[90px] tw-flex tw-items-center tw-justify-center"
                                    >
                                        <img
                                            [src]="item.icon"
                                            class="tw-w-full tw-h-full tw-object-contain"
                                            alt="Step icon"
                                        />
                                    </div>
                                    <p
                                        class="tw-text-lg tw-font-bold tw-text-gray-900"
                                    >
                                        {{
                                            selectedLanguage === "en"
                                                ? item?.title
                                                : item?.titleBM
                                        }}
                                    </p>
                                    <p class="tw-text-sm tw-text-gray-600">
                                        {{
                                            selectedLanguage === "en"
                                                ? item?.description
                                                : item?.descriptionBM
                                        }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Dot indicators for carousel -->
                    <div class="tw-flex tw-justify-center tw-mt-2 tw-gap-2">
                        <button
                            *ngFor="let item of steps; let i = index"
                            (click)="setActiveIndex(i)"
                            [class.tw-bg-blue-500]="activeIndex === i"
                            [class.tw-bg-gray-300]="activeIndex !== i"
                            class="tw-w-2 tw-h-2 tw-rounded-full tw-transition-all"
                            [attr.aria-label]="'Go to step ' + (i + 1)"
                        ></button>
                    </div>
                </div>
            </div>

            <div
                class="tw-flex tw-justify-center tw-items-center tw-mt-2 tw-flex-col md:tw-flex-row"
                *ngIf="showBanks"
            >
                <button
                    ga-event-id="apply_now_button_about_imsme_click"
                    ga-event-category="About imSME Button"
                    ga-event-label="Contact Us Text Click"
                    ga-track="track"
                    class="tw-my-4 tw-mx-2 tw-bg-[#ff8819] tw-w-[207.05px] tw-h-[56px] tw-text-white tw-px-8 tw-py-5 tw-rounded-full tw-font-medium tw-flex tw-flex-row tw-justify-center tw-items-center tw-gap-2"
                    (click)="
                        !disableMatchingProductsBtn && onClickEligibility()
                    "
                >
                    {{ "COMMON.APPLY_NOW" | translate }}
                </button>
                <button
                    ga-event-id="check_eligibilty_button_msmefinancing_click"
                    ga-event-category="MSME Financing Button"
                    ga-event-label="Check Eligibility Button Button Click"
                    ga-track="track"
                    class="tw-my-4 tw-mx-2 tw-bg-blue-600 tw-text-white tw-px-8 tw-py-4 tw-rounded-full tw-font-medium hover:tw-bg-blue-700 tw-flex tw-flex-row tw-justify-center tw-items-center tw-gap-2"
                    (click)="
                        !disableMatchingProductsBtn && onClickEligibility()
                    "
                >
                    <img
                        src="/assets/images/icons/Calculator-white.png"
                        class="tw-h-6 tw-w-auto"
                        alt="Calculate"
                    />
                    {{ "NEW_PRODUCTS.CHECK_ELIGIBILITY" | translate }}
                </button>
            </div>
        </div>
    </section>
</ng-container>

<ng-container *ngIf="IsDGPSteps">
    <section class="tw-py-5 tw-px-4 lg:tw-px-20 tw-bg-white">
        <div class="tw-py-5 tw-bg-white tw-text-left">
            <p
                class="tw-text-center sm:tw-text-left tw-text-[28px] md:tw-text-[40px] tw-w-full tw-text-[#0F3172] tw-font-bold"
            >
                {{
                    "NEW_PRODUCTS.APPLY_NOW_STEPS.DIGITAL_GUARANTEE" | translate
                }}
            </p>

            <!-- Desktop Timeline -->
            <div
                class="tw-hidden md:tw-block"
                [ngClass]="showBanks ? 'tw-my-10' : 'tw-mt-[40px] tw-mb-[16px]'"
            >
                <ol class="tw-flex tw-items-start tw-justify-between">
                    <!-- Dynamic Timeline Items -->
                    <li
                        *ngFor="
                            let step of dgpSteps;
                            let first = first;
                            let last = last;
                            let i = index
                        "
                        class="tw-relative tw-flex-1 tw-flex tw-flex-col tw-items-center"
                    >
                        <!-- Line and Dot -->
                        <div
                            class="tw-relative tw-flex tw-justify-center tw-items-center tw-h-16 tw-w-full"
                        >
                            <!-- Line logic: different for first and last items -->
                            <div
                                *ngIf="first"
                                class="tw-absolute tw-top-1/2 tw-left-1/2 tw-w-full tw-h-1 tw-bg-[#4B6EEC]"
                            ></div>
                            <div
                                *ngIf="!first && !last"
                                class="tw-absolute tw-top-1/2 tw-left-0 tw-w-full tw-h-1 tw-bg-[#4B6EEC]"
                            ></div>
                            <div
                                *ngIf="last"
                                class="tw-absolute tw-top-1/2 tw-left-0 tw-w-[50%] tw-h-1 tw-bg-[#4B6EEC]"
                            ></div>

                            <!-- Dot loggic -->
                            <div
                                class="tw-z-10 tw-flex tw-items-center tw-justify-center tw-w-5 tw-h-5 tw-bg-[#4B6EEC] tw-rounded-full"
                            >
                                <span
                                    class="tw-bg-white tw-w-2.5 tw-h-2.5 tw-rounded-full"
                                ></span>
                            </div>
                        </div>

                        <!-- Step name render-->
                        <div>
                            <p class="tw-font-semibold">
                                {{
                                    selectedLanguage === "en"
                                        ? step?.step
                                        : step?.stepBM
                                }}
                            </p>
                        </div>

                        <!-- Icon render -->
                        <div
                            class="tw-w-[90px] tw-h-[90px] tw-flex tw-items-center tw-justify-center"
                        >
                            <img
                                [src]="step.icon"
                                class="tw-w-full tw-h-full tw-object-contain"
                                alt="Step icon"
                            />
                        </div>

                        <!-- Content render -->
                        <div class="tw-mt-3 tw-text-center tw-px-7">
                            <p
                                class="tw-text-lg tw-font-bold tw-text-black-900"
                            >
                                {{
                                    selectedLanguage === "en"
                                        ? step?.title
                                        : step?.titleBM
                                }}
                            </p>
                            <p class="tw-text-sm tw-text-black-600">
                                {{
                                    selectedLanguage === "en"
                                        ? step?.description
                                        : step?.descriptionBM
                                }}
                            </p>
                        </div>
                    </li>
                </ol>
            </div>

            <!-- Mobile Carousel Version -->
            <div *ngIf="isMobile" class="tw-w-full">
                <div class="tw-relative">
                    <div
                        *ngFor="let item of dgpSteps; let i = index"
                        [@slideAnimation]="getSlideState(i)"
                        [style.display]="i === activeIndex ? 'block' : 'none'"
                        class="tw-w-full tw-transition-opacity tw-duration-300"
                    >
                        <div
                            class="tw-relative tw-p-4"
                            style="min-height: 300px"
                        >
                            <!-- Timeline with centered dot and line extending to the right -->
                            <div
                                class="tw-flex tw-justify-center tw-relative tw-h-6 tw-mb-5"
                            >
                                <!-- Line before dot (hidden) -->
                                <div
                                    [class.tw-bg-transparent]="i === 0"
                                    [class.tw-bg-blue-500]="i !== 0"
                                    class="tw-h-0.5 tw-flex-1 tw-my-3"
                                ></div>

                                <!-- Centered dot -->
                                <div
                                    class="tw-w-6 tw-h-6 tw-rounded-full tw-bg-blue-500 tw-flex tw-items-center tw-justify-center tw-text-white tw-z-10"
                                >
                                    <span
                                        class="tw-bg-white tw-w-2.5 tw-h-2.5 tw-rounded-full"
                                    ></span>
                                </div>

                                <!-- Line after dot -->
                                <div
                                    [class.tw-bg-transparent]="
                                        i === dgpSteps.length - 1
                                    "
                                    [class.tw-bg-blue-500]="
                                        i !== dgpSteps.length - 1
                                    "
                                    class="tw-h-0.5 tw-flex-1 tw-my-3"
                                ></div>
                            </div>

                            <!-- Step content -->
                            <div class="tw-pt-6">
                                <div
                                    class="tw-flex tw-flex-col tw-items-center tw-text-center"
                                >
                                    <!-- Step name -->
                                    <div>
                                        <p class="tw-font-semibold">
                                            {{
                                                selectedLanguage === "en"
                                                    ? item?.step
                                                    : item?.stepBM
                                            }}
                                        </p>
                                    </div>
                                    <!-- Icon -->
                                    <div
                                        class="tw-w-[90px] tw-h-[90px] tw-flex tw-items-center tw-justify-center"
                                    >
                                        <img
                                            [src]="item.icon"
                                            class="tw-w-full tw-h-full tw-object-contain"
                                            alt="Step icon"
                                        />
                                    </div>
                                    <p
                                        class="tw-text-lg tw-font-bold tw-text-gray-900"
                                    >
                                        {{
                                            selectedLanguage === "en"
                                                ? item?.title
                                                : item?.titleBM
                                        }}
                                    </p>
                                    <p class="tw-text-sm tw-text-gray-600">
                                        {{
                                            selectedLanguage === "en"
                                                ? item?.description
                                                : item?.descriptionBM
                                        }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Dot indicators for carousel -->
                    <div class="tw-flex tw-justify-center tw-mt-2 tw-gap-2">
                        <button
                            *ngFor="let item of dgpSteps; let i = index"
                            (click)="setActiveIndex(i)"
                            [class.tw-bg-blue-500]="activeIndex === i"
                            [class.tw-bg-gray-300]="activeIndex !== i"
                            class="tw-w-2 tw-h-2 tw-rounded-full tw-transition-all"
                            [attr.aria-label]="'Go to step ' + (i + 1)"
                        ></button>
                    </div>
                </div>
            </div>

            <div
                class="tw-flex tw-justify-center tw-items-center tw-mt-2 tw-flex-col md:tw-flex-row"
                *ngIf="showBanks"
            >
                <button
                    ga-event-id="apply_now_button_about_imsme_click"
                    ga-event-category="About imSME Button"
                    ga-event-label="Contact Us Text Click"
                    ga-track="track"
                    class="tw-my-4 tw-mx-2 tw-bg-[#ff8819] tw-w-[207.05px] tw-h-[56px] tw-text-white tw-px-8 tw-py-5 tw-rounded-full tw-font-medium tw-flex tw-flex-row tw-justify-center tw-items-center tw-gap-2"
                    (click)="
                        !disableMatchingProductsBtn && onClickEligibility()
                    "
                >
                    {{ "COMMON.APPLY_NOW" | translate }}
                </button>
                <button
                    class="tw-my-4 tw-mx-2 tw-bg-blue-600 tw-text-white tw-px-8 tw-py-4 tw-rounded-full tw-font-medium hover:tw-bg-blue-700 tw-flex tw-flex-row tw-justify-center tw-items-center tw-gap-2"
                    (click)="
                        !disableMatchingProductsBtn && onClickEligibility()
                    "
                >
                    <img
                        src="/assets/images/icons/Calculator-white.png"
                        class="tw-h-6 tw-w-auto"
                        alt="Calculate"
                    />
                    {{ "NEW_PRODUCTS.CHECK_ELIGIBILITY" | translate }}
                </button>
            </div>
        </div>
    </section>
</ng-container>

<ng-container *ngIf="isAboutUs">
    <section class="tw-py-5 tw-px-4 lg:tw-px-20 tw-bg-white">
        <div class="tw-py-5 tw-bg-white tw-text-left">
            <p
                class="tw-text-center sm:tw-text-left tw-text-[20px] md:tw-text-[30px] tw-w-full tw-text-[#0F3172] tw-font-bold"
            >
                {{ "NEW_ABOUT_US.YOUR_JOURNEY" | translate }}
            </p>

            <!-- Desktop Timeline -->
            <div class="tw-hidden md:tw-block tw-my-10">
                <ol class="tw-flex tw-items-start tw-justify-between">
                    <!-- Dynamic Timeline Items -->
                    <li
                        *ngFor="
                            let step of aboutUsSteps;
                            let first = first;
                            let last = last;
                            let i = index
                        "
                        class="tw-relative tw-flex-1 tw-flex tw-flex-col tw-items-center"
                    >
                        <!-- Line and Dot -->
                        <div
                            class="tw-relative tw-flex tw-justify-center tw-items-center tw-h-16 tw-w-full"
                        >
                            <!-- Line logic: different for first and last items -->
                            <div
                                *ngIf="first"
                                class="tw-absolute tw-top-1/2 tw-left-1/2 tw-w-full tw-h-1 tw-bg-[#4B6EEC]"
                            ></div>
                            <div
                                *ngIf="!first && !last"
                                class="tw-absolute tw-top-1/2 tw-left-0 tw-w-full tw-h-1 tw-bg-[#4B6EEC]"
                            ></div>
                            <div
                                *ngIf="last"
                                class="tw-absolute tw-top-1/2 tw-left-0 tw-w-[50%] tw-h-1 tw-bg-[#4B6EEC]"
                            ></div>

                            <!-- Dot loggic -->
                            <div
                                class="tw-z-10 tw-flex tw-items-center tw-justify-center tw-w-5 tw-h-5 tw-bg-[#4B6EEC] tw-rounded-full"
                            >
                                <span
                                    class="tw-bg-white tw-w-2.5 tw-h-2.5 tw-rounded-full"
                                ></span>
                            </div>
                        </div>

                        <!-- Step name render-->
                        <div>
                            <p class="tw-font-semibold">
                                {{
                                    selectedLanguage === "en"
                                        ? step?.step
                                        : step?.stepBM
                                }}
                            </p>
                        </div>

                        <!-- Icon render -->
                        <div
                            class="tw-w-[90px] tw-h-[90px] tw-flex tw-items-center tw-justify-center"
                        >
                            <img
                                [src]="step.icon"
                                class="tw-w-full tw-h-full tw-object-contain"
                                alt="Step icon"
                            />
                        </div>

                        <!-- Content render -->
                        <div class="tw-mt-3 tw-text-center tw-px-7">
                            <p
                                class="tw-text-[18px] tw-font-bold tw-text-black-900"
                            >
                                {{
                                    selectedLanguage === "en"
                                        ? step?.title
                                        : step?.titleBM
                                }}
                            </p>
                            <p class="tw-text-[16px] tw-text-black-600">
                                {{
                                    selectedLanguage === "en"
                                        ? step?.description
                                        : step?.descriptionBM
                                }}
                            </p>
                        </div>
                    </li>
                </ol>
            </div>

            <!-- Mobile Carousel Version -->
            <div *ngIf="isMobile" class="tw-w-full">
                <div class="tw-relative">
                    <div
                        *ngFor="let item of aboutUsSteps; let i = index"
                        [@slideAnimation]="getSlideState(i)"
                        [style.display]="i === activeIndex ? 'block' : 'none'"
                        class="tw-w-full tw-transition-opacity tw-duration-300"
                    >
                        <div
                            class="tw-relative tw-p-4"
                            style="min-height: 300px"
                        >
                            <!-- Timeline with centered dot and line extending to the right -->
                            <div
                                class="tw-flex tw-justify-center tw-relative tw-h-6 tw-mb-5"
                            >
                                <!-- Line before dot (hidden) -->
                                <div
                                    [class.tw-bg-transparent]="i === 0"
                                    [class.tw-bg-blue-500]="i !== 0"
                                    class="tw-h-0.5 tw-flex-1 tw-my-3"
                                ></div>

                                <!-- Centered dot -->
                                <div
                                    class="tw-w-6 tw-h-6 tw-rounded-full tw-bg-blue-500 tw-flex tw-items-center tw-justify-center tw-text-white tw-z-10"
                                >
                                    <span
                                        class="tw-bg-white tw-w-2.5 tw-h-2.5 tw-rounded-full"
                                    ></span>
                                </div>

                                <!-- Line after dot -->
                                <div
                                    [class.tw-bg-transparent]="
                                        i === aboutUsSteps.length - 1
                                    "
                                    [class.tw-bg-blue-500]="
                                        i !== aboutUsSteps.length - 1
                                    "
                                    class="tw-h-0.5 tw-flex-1 tw-my-3"
                                ></div>
                            </div>

                            <!-- Step content -->
                            <div class="tw-pt-6">
                                <div
                                    class="tw-flex tw-flex-col tw-items-center tw-text-center"
                                >
                                    <!-- Step name -->
                                    <div>
                                        <p
                                            class="tw-font-semibold tw-text-[20px]"
                                        >
                                            {{
                                                selectedLanguage === "en"
                                                    ? item?.step
                                                    : item?.stepBM
                                            }}
                                        </p>
                                    </div>
                                    <!-- Icon -->
                                    <div
                                        class="tw-w-[90px] tw-h-[90px] tw-flex tw-items-center tw-justify-center"
                                    >
                                        <img
                                            [src]="item.icon"
                                            class="tw-w-full tw-h-full tw-object-contain"
                                            alt="Step icon"
                                        />
                                    </div>
                                    <p
                                        class="tw-text-lg tw-font-bold tw-text-[20px] tw-text-gray-900"
                                    >
                                        {{
                                            selectedLanguage === "en"
                                                ? item?.title
                                                : item?.titleBM
                                        }}
                                    </p>
                                    <p class="tw-text-[18px] tw-text-gray-600">
                                        {{
                                            selectedLanguage === "en"
                                                ? item?.description
                                                : item?.descriptionBM
                                        }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Dot indicators for carousel -->
                    <div class="tw-flex tw-justify-center tw-mt-2 tw-gap-2">
                        <button
                            *ngFor="let item of aboutUsSteps; let i = index"
                            (click)="setActiveIndex(i)"
                            [class.tw-bg-blue-500]="activeIndex === i"
                            [class.tw-bg-gray-300]="activeIndex !== i"
                            class="tw-w-2 tw-h-2 tw-rounded-full tw-transition-all"
                            [attr.aria-label]="'Go to step ' + (i + 1)"
                        ></button>
                    </div>
                </div>
            </div>
            <div
                class="tw-flex tw-justify-center tw-items-center tw-mt-2 tw-flex-col md:tw-flex-row"
            >
                <button
                    ga-event-id="apply_now_button_about_imsme_click"
                    ga-event-category="About imSME Button"
                    ga-event-label="Contact Us Text Click"
                    ga-track="track"
                    class="tw-my-4 tw-mx-2 tw-bg-[#ff8819] tw-w-[207.05px] tw-h-[56px] tw-text-white tw-px-8 tw-py-5 tw-rounded-full tw-font-medium tw-flex tw-flex-row tw-justify-center tw-items-center tw-gap-2"
                    (click)="
                        !disableMatchingProductsBtn && onClickEligibility()
                    "
                >
                    {{ "COMMON.APPLY_NOW" | translate }}
                </button>
                <button
                    ga-event-id="check_eligibilty_button_about_imsme_click"
                    ga-event-category="About imSME Button"
                    ga-event-label="Contact Us Text Click"
                    ga-track="track"
                    class="tw-text-[18px] tw-my-4 tw-mx-2 tw-bg-blue-600 tw-text-white tw-px-8 tw-py-4 tw-rounded-full tw-font-medium hover:tw-bg-blue-700 tw-flex tw-flex-row tw-justify-center tw-items-center tw-gap-2"
                    (click)="
                        !disableMatchingProductsBtn && onClickEligibility()
                    "
                >
                    <img
                        src="/assets/images/icons/Calculator-white.png"
                        class="tw-h-6 tw-w-auto"
                        alt="Calculate"
                    />
                    {{ "NEW_PRODUCTS.CHECK_ELIGIBILITY" | translate }}
                </button>
            </div>
        </div>
    </section>
</ng-container>
